import { render } from "./MainQuotes.vue?vue&type=template&id=1c0c5693&scoped=true"
import script from "./MainQuotes.vue?vue&type=script&lang=js"
export * from "./MainQuotes.vue?vue&type=script&lang=js"

import "./MainQuotes.vue?vue&type=style&index=0&id=1c0c5693&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0c5693"]])

export default __exports__